import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Ctas from '../../../Core/Ctas';
import starRating from '../../../../images/star-rating.svg';

export const Banner = styled.div`
  margin: 40px auto;
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 70px auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 100px auto;
  }

  &.image-left-bottom-aligned,
  &.image-bottom-aligned {
    margin: -40px auto 40px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: -70px auto 70px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      margin: -100px auto 100px;
    }
  }

  &.app-banner-grey-bkg {
    background-color: ${themeGet('colors.stone')};
  }

  &.digital-product-banner {
    margin: 2.5rem auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 5rem auto;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: 6.25rem auto;
    }
  }
`;

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  &.image-left-bottom-aligned,
  &.image-bottom-aligned {
    border-bottom: 1px solid ${themeGet('colors.border-grey')};
    min-height: 350px;
  }
  margin: 0 auto;
  max-width: ${themeGet('media.grid')};
  width: calc(100% - ${themeGet('media.grid-gutter.2')});
  gap: 1.5rem;

  ${Banner}.app-banner-grey-bkg & {
    border-bottom: none;
    padding-top: 24px;
    padding-bottom: 40px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
    flex-direction: row;
    margin: auto;
    &.image-left-bottom-aligned,
    &.image-bottom-aligned {
      min-height: 400px;
    }
    &.digital-banking-banner {
      margin: 0 1rem;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.5')});
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.image-left-bottom-aligned,
    &.image-bottom-aligned {
      border-bottom: 1.7px solid ${themeGet('colors.border-grey')};
      min-height: 450px;
    }
  }

  ${Banner}.digital-product-banner & {
    min-height: unset;
    gap: 1.5rem;
    flex-direction: column;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      gap: 1rem;
      flex-direction: row;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  margin: 1.5rem auto auto;
  h2 {
    margin-bottom: 1.5rem;
  }

  p {
    font-size: 1rem;
    line-height: 150%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: auto 0;
    padding: 0;
    width: 50%;

    ${Wrapper}.image-bottom-aligned & {
      bottom: 5%;
    }

    ${Wrapper}.image-left-bottom-aligned & {
      order: 2;
      right: 0;
    }

    ${Wrapper}.image-left & {
      order: 2;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    ${Wrapper}.image-left & {
      padding-right: 80px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${Wrapper}.image-bottom-aligned & {
      bottom: 15%;
    }
  }

  ${Banner}.digital-product-banner & {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    margin: unset;
    padding: 1.5rem 0;
    order: 2;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding: 0 1.5rem 1rem 1.5rem;
      order: 1;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 60%;
      padding: 1.5rem 1.5rem 1.5rem 3rem;
      order: 2;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      padding: 1.5rem 8.5rem 1.5rem 3rem;
    }

    h2 {
      font-size: 1.5rem;
      line-height: 130%;
    }
  }
`;

export const Features = styled.div`
  display: flex;
  flex-direction: column;

  > a {
    justify-content: unset;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${Wrapper}.image-bottom-aligned &,
    ${Wrapper}.image-left-bottom-aligned & {
      flex-direction: row;
    }
  }
`;

export const Product = styled.div`
  margin: auto;
  display: flex;
  position: relative;
  justify-content: center;
  margin-bottom: 2rem;

  ${Wrapper}.image-bottom-aligned &,
  ${Wrapper}.image-left-bottom-aligned & {
    margin-top: 3rem;
    margin-bottom: 0rem;
  }

  ${Wrapper}.image-left &,
  ${Wrapper}.image-right & {
    margin-top: 2rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: auto;
    ${Wrapper}.image-bottom-aligned & {
      bottom: 0;
    }
    ${Wrapper}.image-left-bottom-aligned & {
      order: 1;
      bottom: 0;
    }

    ${Wrapper}.image-left & {
      order: 1;
    }

    ${Wrapper}.image-left &,
    ${Wrapper}.image-right & {
      margin: auto;
    }
  }

  ${Banner}.digital-product-banner & {
    display: flex;
    margin: unset;
    width: 100%;
    order: 1;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      order: 2;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 40%;
      padding-left: 1.5rem;
      order: 1;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      padding-left: 7rem;
    }
  }
`;

export const Img = styled(Image)`
  width: 175px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 200px;

    ${Wrapper}.image-bottom-aligned & {
      width: 275px;
      position: absolute !important;
      bottom: 0;
    }

    ${Wrapper}.image-left-bottom-aligned & {
      width: 275px;
      position: absolute !important;
      bottom: 0;
    }
  }

  @media only screen and (min-width: ${themeGet(
      'breakpoints.md',
    )}) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    ${Wrapper}.image-bottom-aligned & {
      height: auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 275px;

    ${Wrapper}.image-bottom-aligned & {
      width: 400px;
    }

    ${Wrapper}.image-left-bottom-aligned & {
      width: 400px;
    }
  }

  ${Banner}.digital-product-banner & {
    width: unset;
    max-width: 400px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    }
  }
`;

export const RatingWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  gap: 1.25rem;
  margin-top: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 2rem;
  }
`;

export const StarRating = styled.div`
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 1.95rem;
  &:after {
    display: inline-block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    top: 3px;
    margin-left: 0.5rem;
    background-image: url(${starRating});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }
`;

export const UserCounts = styled.div`
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 1.95rem;
`;

export const StyledCtas = styled(Ctas)`
  margin: 1rem 0 0;
  ${Wrapper}.image-bottom-aligned &,
  ${Wrapper}.image-left-bottom-aligned & {
    margin-top: 0;
  }
  a {
    justify-content: unset;
    margin-bottom: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 1rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-top: 1.5rem;
    ${Wrapper}.image-bottom-aligned &,
    ${Wrapper}.image-left-bottom-aligned & {
      margin-top: 0;
    }
  }

  ${Banner}.digital-product-banner & {
    margin: 1.5rem 0 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-top: 1.5rem;
    }
  }
`;
